<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{on, attrs}">
      <v-btn
        color="primary"
        :loading="loading"
        v-bind="attrs"
        v-on="on"
      >
        {{ btnText }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Exportar saldo dos usuário
      </v-card-title>
      <v-card-text>
        <input-date
          id="input:initialDate"
          v-model="payload.initialDate"
          label="Data inicial"
          :rules="[requiredRule]"
          required
        />
        <input-text
          id="input:userSystemId"
          v-model="payload.userSystemId"
          label="ID Cardmais"
          outlined
        />
        <input-text
          id="input:clientId"
          v-model="payload.clientId"
          label="ID Cliente"
          outlined
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          id="closeBtn"
          outlined
          color="primary"
          @click="closeModal()"
        >
          Cancelar
        </v-btn>
        <v-btn
          id="send"
          class="white--text ml-2"
          color="#2ABD49"
          :disabled="isDisabled"
          :loading="loading"
          @click="confirmTerminate()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ReportConfirmMangerModalVue from '@/app/arch/components/modals/ReportConfirmMangerModal.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import DateMixin from '@/app/arch/mixins/DateMixin';
import UsersRequest from '../../UsersRequest';

export default {
  name: 'UserBallanceReportButton',
  extends: ReportConfirmMangerModalVue,
  mixins: [RulesMixin, DateMixin],
  data: () => ({
    dialog: false,
    requestClass: UsersRequest,
    totalItens: 0,
    btnText: 'Exportar saldo',
    successMessage: 'Saldo dos usuários exportados com sucesso!',
    crudListName: 'UserList',
    payload: {
      initialDate: '',
      clientId: '',
      userSystemId: '',
    },
  }),
  computed: {
    faultReportParams() {
      return {
        isActive: true,
      };
    },
    isDisabled() {
      return !this.payload.initialDate;
    },
    handleParams() {
      return () => {
        const { clientId, initialDate, userSystemId } = this.payload;
        return {
          request: {
            ignorePagination: true,
            reportType: 'Csv',
          },
          filter: {
            clientId,
            userSystemId,
            initialDate: this.formatDate(initialDate, 'YYYY-MM-DD'),
          },
        };
      };
    },
    proxyRequest() {
      return (payload) => this.requestClass.balanceReport(payload);
    },
  },
  methods: {
    closeModal() {
      this.dialog = !this.dialog;
    },
    confirmCallBack(data, callback) {
      if (data.value) {
        callback();
      } else {
        this.closeModal();
      }
    },
  },
};
</script>
